import axios from 'axios'
import qs from 'qs'

const prefix = `https://m.xinli001.com/`
const prefixWWW = 'https://www.xinli001.com'
const prefixYapi = 'https://yiapi.xinli001.com/'
const prefixYiapp = `https://yiapp.xinli001.com/`
const prefixMse = `https://mse.xinli001.com/`

// 首页接口
export const consultIndex = config => {
  return axios.get(`${prefixMse}zixun/api/home/index/v4`, config)
}

// 用户咨询信息
export const consultUser = params =>
  axios.get(`${prefix}consult/consult_user`, { params })

// 获取未读取订单消息数量
export const consultOrderNumUnread = () =>
  axios.get(`${prefix}consultation/order-num-unread`)

// 动态
export const consultDynamics = () =>
  axios.get(`${prefix}consult/consult_dynamics`)

// 榜单详情
export const consultRankDetail = ({ id }) =>
  axios.get(`${prefix}consult/consult_rank_detail`, { params: { id } })

export const newConsultRankDetail = params =>
  axios.get(`${prefix}consult/teacher_list_ab`, { params })

export const getLessonTitleById = id => axios.get(`${prefix}lessondetail/${id}`)

// 最新入驻 - 最佳人气
export const consultSpecial = ({ type, page }) => {
  return axios.get(`${prefix}webzixun/${type}`, { params: { page } })
}

export const teacherListOption = () =>
  axios.get(`${prefix}consult/teacher_select_option`)

export const teacherList = ({ page, selectObj, channelId }) =>
  axios.get(`${prefix}consult/teacher_list_v4`, {
    params: Object.assign({ page, channel_id: channelId }, selectObj)
  })

export const scheduleList = ({ page, selectObj, channelId }) =>
  axios.get(`${prefix}consult/teacher_list_v5`, {
    params: Object.assign({ page, channel_id: channelId }, selectObj)
  })

export const scheduleListForAbTest = ({ page, selectObj, channelId }) =>
  axios.get(`${prefix}consult/teacher_list_ab`, {
    params: Object.assign({ page, channel_id: channelId }, selectObj)
  })

export const teacherListV5 = params =>
  axios.get(`${prefix}consult/teacher_list_v5`, {
    params
  })

export const teacherListV5ForAbTest = params =>
  axios.get(`${prefix}consult/teacher_list_ab`, {
    params
  })

export const teacherListAd = ({ adsite, title }) =>
  axios.get(
    `${prefix}ajax/full-ad.json?adsite=${adsite}${
      title ? `&title=${title}` : ''
    }`
  )

// 用户心声，感谢信
export const thankrate = ({ page }) =>
  axios.get(`${prefix}webzixun/thankrate`, { params: { page } })

// 咨询师列表
export const consultTeacherList = params =>
  axios.get(`${prefix}webzixun/teacher_list`, { params })

// 用户心声，感谢信点赞
export const ratezan = ({ id }) =>
  axios.post(`${prefix}webzixun/ratezan`, qs.stringify({ id }))

// 咨询师主页
export const basicinfo = ({ id }) =>
  axios.get(`${prefix}consultteacher/basicinfo`, {
    params: {
      redirect: 0, // @zhaoxiaomeng
      teacher_id: id
    }
  })

//上传图片
export const uploadimage = params => {
  return axios.post(
    `${prefixWWW}/ajax/ueditor.json?action=uploadimage&type=base64`,
    qs.stringify(params)
  )
}
// 咨询师主页，2020周年庆的banner图
export const fetchYearBanner = () =>
  axios.get(`${prefix}ajax/full-ad.json?adsite=zixun-anniversary-festival`)

// 评价列表
export const ratelist = ({
  id,
  page = 1,
  rate_id = '',
  sort,
  type,
  score = 'all'
}) => {
  let params = {
    teacher_id: id,
    page,
    sort,
    rate_id,
    type,
    score
  }
  if (params.sort) {
    params.sort = sort
  }
  return axios.get(`${prefix}consultteacher/ratelist`, {
    params
  })
}

// 评价列表咨询师信息
export const rateListTeacherInfo = ({ id }) => {
  return axios.get(`${prefix}consultteacher/ratecount`, {
    params: {
      teacher_id: id
    }
  })
}

// 咨询师主页动态
export const dynamicsList = ({ id }) =>
  axios.get(`${prefix}consultteacher/dynamics?teacher_id=` + id)

// 咨询师主页优惠信息
export const teacherCoupons = ({ id, type }) =>
  axios.get(`${prefix}consultteacher/coupons`, {
    params: {
      teacher_id: id,
      type
    }
  })

// 领券
export const getCoupon = ({ id, ...params }) =>
  axios.get(`${prefix}coupon/receivecoupon`, {
    params: { coupon_id: id, ...params }
  })

// 老师喜欢/关注
export const followToggle = ({ id }) =>
  axios.post(`${prefix}ajax/user-follow-toggle_v2.json`, { user_id: id })

//推荐咨询师
export const recommendTeacher = () =>
  axios.get(`${prefix}consult/recommend_teacher`)

// 检查用户和咨询师互黑
export const contactPermit = userId =>
  axios.get(`${prefix}contact/${userId}/permit`)

//获取广告位数据
export const getAdLists = params => {
  return axios.get(prefixMse + `zixun/api/home/ad/list`, { params })
}

// 咨询师日程表
export const teacherSchedule = params =>
  axios.get(`${prefix}consult/schedule/teacher`, {
    params: { teacher_id: params.id }
  })

// 获取渠道信息
export const channelInfo = ({ channel_id = '', channel_flag = '' }) =>
  axios.get(`${prefix}webzixun/channel-info`, {
    params: {
      out_channel_id: channel_id,
      in_channel_flag: channel_flag
    }
  })

// 预咨询老师列表
export const preConsultList = page =>
  axios.get(`${prefix}consult/activity/teachers`, {
    params: {
      activity_id: 41,
      size: 10,
      page
    }
  })

// 主题信息接口
export const activityInfo = params =>
  axios.get(`${prefix}consult_activity/common/activity-info`, { params })

// 主题信息接口
export const activityJoinCheck = params =>
  axios.get(`${prefix}consult_activity/common/join-check`, {
    params,
    disabledUnLoginInterceptors: true
  })

// 咨询师主页分享 teacher_id =
export const teacherShare = params =>
  axios.get(`${prefix}consultteacher/share`, { params })

// 咨询师主页浏览 teacher_id =
export const teacherBrowse = params =>
  axios.get(`${prefix}consultteacher/browse`, { params })

// 咨询师主页弹幕 teacher_id =
export const teacherBarrage = params =>
  axios.get(`${prefix}consultteacher/barrage`, { params })

// 用于获取定位
export const loginInfo = params =>
  axios.get(`${prefix}webzixun/login_info`, { params })

// 获取预览
export const preview = () => axios.get(`${prefix}apply/preview`)

//获取服务对象
export const serviceObjects = () => axios.get(`${prefix}apply/service-objects`)

//获取标签疗法
export const tagAndTherapies = () =>
  axios.get(`${prefix}apply/tags-and-therapies`)

// 创建订单
// * to_user_id 咨询师ID
// * zx_num 咨询次数
// * waytype 咨询方式，voice：语音，video：视频，face：面对面
// * phone 手机号
// * schedule_time 咨询时间
// * activity_id 活动id
// * coupon_id 优惠券ID
// * name 姓名
// * age 年龄
// * gender 性别，1：女，2：男
// * tag 标签
// * content 问题内容
// * emergency_name 紧急联系人名称
// * relationship 紧急联系人关系
// * emergency_mobile 紧急联系人电话
// * expect_result 期待结果
// * free_time 空闲时间
// * emotional_state 感情状态
export const createOrder = params =>
  axios.post(`${prefix}consult_order/create_order`, params)

// channelId orderNo
export const getCpReportData = params =>
  axios.get(
    `https://lingxi.xinli001.com/lingxi/service/notLogin/getReportDataUrl`,
    {
      params
    }
  )

export const lastYuyue = () => axios.get(`${prefix}user/lastyuyue`)

export const loginStatus = params =>
  axios.get(`${prefix}webzixun/login_status`, { params })

// 咨询套餐活动--活动详情
export const hdActivityInfo = params =>
  axios.get(`${prefix}consult/package-activity/activity-info`, { params })

export const hdActivityJoinCheck = params =>
  axios.get(`${prefix}consult/package-activity/join-check`, {
    params
  })

export const hdActivityCreateOrder = data =>
  axios.post(`${prefix}consult/package-activity/create-order`, data)

export const consultHdCoupon = ({ activity_id }) =>
  axios.get(`${prefix}consult/package-activity/coupons`, {
    params: {
      activity_id
    }
  })

export const consultHdUserCoupon = ({ activity_id }) =>
  axios.get(`${prefix}consult/package-activity/user-coupons`, {
    params: {
      activity_id
    }
  })

export const phoneLogin = data =>
  axios.post(
    `${prefix}consult_activity/popularize/phone_login?token=${data.token}`,
    data
  )

export const fetchQrcode = params =>
  axios.get(`${prefix}common/qr-code`, { params })

// 咨询领取学生专属优惠券
export const receiveStudentCoupon = () =>
  axios.get(`${prefix}consult_discount/receive_student_coupon`)

// 测评导流咨询师列表
export const consultCepingList = (params = {}) =>
  axios.get(`${prefix}consult/teacher-ceping-list`, { params })

// 短信模板进入app获取测评导流咨询赠送优惠券咨询师
export const fetchCouponTeacher = () =>
  axios.get(`${prefix}consultteacher/diversion_give_coupon_teacher`)

// 咨询师个人页视频列表
export const videoList = params =>
  axios.get(`${prefix}consult/talk_videos`, { params })

// 咨询师个人页访谈列表
export const interViewList = params =>
  axios.get(`${prefix}teacher/interview/list`, { params })

// 咨询首页视频列表
export const consultHomeVideoList = () =>
  axios.get(`${prefix}consult/talk_lists`)

// 咨询师视频详情
export const videoDetail = params =>
  axios.get(`${prefix}consult/talk_detail`, { params })

/**
 * 视频点赞 & 收藏 & 上报首次播放
 * @param type (zan: 点赞 | play: 播放统计 | fav: 收藏)
 * @returns
 */
export const videoOperation = data =>
  axios.post(`${prefix}consult/talk_operation`, data)

// 咨询套餐活动咨询师列表
export const consultPackageList = (params = {}) =>
  axios.get(`${prefix}consult_package/teacher_list`, { params })

// 咨询套餐用户可参与次数
export const consultPackageRestTimes = (params = {}) =>
  axios.get(`${prefix}consult_package/user_rest_times`, { params })

// https://yapi.xinli001.com/project/22/interface/api/13151
export const channelAds = ({ channel_id }) =>
  axios.get(`${prefix}webzixun/channel-ads`, { params: { channel_id } })

export const teacherVisit = ({ teacher_id }) =>
  axios.get(`${prefix}consultteacher/visit`, {
    params: {
      teacher_id
    }
  })

// 医院转介绑定接口 https://yapi.xinli001.com/project/22/interface/api/14146
export const introduceBindChannel = data =>
  axios.post(`${prefix}introduce/bind-channel`, data)

// 用户最近购买及浏览
export const recentTeachers = () =>
  axios.get(`${prefix}webzixun/user_pay_and_view`)

/**
 * @param 心理咨询指南视频列表
 * @param https://yapi.xinli001.com/project/22/interface/api/19816
 */
export const consultVideoList = params =>
  axios.get(`${prefix}consult-guide/video_lists`, { params })

/**
 * @param 获取心理咨询文章列表
 * @param https://yapi.xinli001.com/project/22/interface/api/19844
 */
export const consultArticleList = params =>
  axios.get(`${prefixMse}zixun/api/guide/articleList`, { params })

/**
 * @param 获取优惠券信息
 * @param https://yapi.xinli001.com/project/22/interface/api/19016
 */
export const getCouponinfo = params =>
  axios.get(`${prefix}coupon/couponinfo`, { params })

/**
 * @param 用户领取优惠券
 * @param https://yapi.xinli001.com/project/22/interface/api/19930
 */
export const setReceivecoupon = params =>
  axios.get(`${prefix}consult-guide/get_receive_coupon`, {
    params,
    disabledUnLoginInterceptors: true
  })

/**
 * @param 用户是否领过新人优惠券
 * @param https://yapi.xinli001.com/project/22/interface/api/19932
 */
export const isNewCoupon = params =>
  axios.get(`${prefix}consult-guide/check_receive_coupon`, {
    params
  })
// 咨询师搜索接口
export const consultSearch = (params = {}) =>
  axios.get(`${prefixYapi}v5/yi/search.json`, { params })

// 邀请新用户双十一
export const inviteUser = (params = {}) =>
  axios.get(`${prefix}consult_activity/2021/double11/invite_user`, { params })

// 邀请新用户邀请有礼
export const inviteUser3 = (params = {}) =>
  axios.get(`${prefix}consult_activity/2022/invite/invite_user`, { params })

// 我的评价
export const getMyEvaluate = (params = {}) =>
  axios.get(`${prefix}new-qingsu/userthankrate`, { params })

// 我的评价统计
export const getMyEvaluateCount = (params = {}) =>
  axios.get(`${prefix}new-qingsu/userratecount`, { params })

export const teacherAttributes = (params = {}) =>
  axios.get(`${prefixMse}zixun/api/home/teacherAttributes`, { params })

export const newConsultUser = params =>
  axios.get(`${prefix}consult/user_consult_statistics`, { params })

export const visitHistory = params =>
  axios.get(`${prefix}consult/user_visit/history`, { params })

export const checkOnline = params =>
  axios.get(`${prefix}zixun-teacher/check-online-activity`, { params })

export const sendImMessage = params =>
  axios.get(`${prefix}consult/adviser_auto_reply`, { params })

export const newUserRecommend = params =>
  axios.get(`${prefix}consult/new_user_recommend`, { params })

// 通过优惠券id获取对应的老师列表
export const fetchCouponTeachers = params =>
  axios.get(`${prefix}consult/coupon_teacher_list`, { params })

// 我的咨询订单-首页
export const userLastProgress = () =>
  axios.get(`${prefix}consult/user_last_progress`)

// 发消息给老师-提示预约咨询时间
export const userAppointmentMessage = params =>
  axios.get(`${prefix}consult/user_appointment_message`, { params })

// 用户确认完成咨询
export const recordComplete = params =>
  axios.get(`${prefix}consult-order/operation/user-complete-consult`, {
    params
  })

// 乱码域名登录后获取身份临时token
export const getIdentity = params =>
  axios.get(`${prefix}platform/get-identity.json`, {
    params
  })

// 搜索页问答列表
export const getSearchPageAnswerList = params =>
  axios.get(`${prefixMse}qingsu/api/consult/teacher/nearly/answers`, {
    params
  })

// 搜索页文章列表
export const getSearchPageArticleList = params =>
  axios.get(`${prefixMse}qingsu/api/consult/teacher/nearly/articles`, {
    params
  })

// 上报用户访问页面次数
export const reportFrequentAccess = params =>
  axios.get(`${prefix}consult_adviser/frequent_access`, {
    params
  })

// 合从消息提醒
export const heCongUnread = params =>
  axios.get(`${prefixYiapp}customer/unread`, {
    params
  })

// 设置合从消息为已读
export const heCongRead = params =>
  axios.post(`${prefixYiapp}customer/haveRead`, qs.stringify(params))

// 学生认证信息
export const studentAuthInfo = () =>
  axios.get(`${prefix}consult/user_identities`, {
    headers: {
      'Cache-Control': 'no-cache'
    }
  })

// 全场通用优惠券
export const getCommonCoupon = () =>
  axios.get(`${prefix}consult/common_coupons`, {})

// 指南详情
export const getArticleDetail = params =>
  axios.get(prefix + `consult-guide/article_info`, {
    params
  })

// 今明已约用户数
export const getScheduleUserNum = () =>
  axios.get(`${prefix}consult/home/schedule_user_num`)

// 用户主题列表
export const getLayeredTags = () =>
  axios.get(`${prefix}consult/home/layered_tags`)

// 咨询新手标签
export const getConsultTags = () => axios.get(`${prefix}consult/consult_tags`)

// 提醒老师受理
export const userremind = params =>
  axios.get(prefix + `yuyue/userremind`, params)

// https://yapi.xinli001.com/project/22/interface/api/49089
export const userNewVisitor = params =>
  axios.get(prefix + `/consult/user_new_visit_name`, params)

// https://yapi.xinli001.com/project/22/interface/api/72177
export const fetchAdviserPopup = params =>
  axios.get(`${prefix}consult/adviser/pop-ups`, params)

// 获取套餐详情接口
export const pkgDetailApi = params =>
  axios.get(`${prefix}consult_activity/common/package-activity-info`, {
    params
  })

// 获取咨询完成页
export const consultCompletePage = params =>
  axios.get(`${prefix}consult/complete_page`, {
    params
  })

// 获取差评页数据
export const consultBadRatePage = params =>
  axios.get(`${prefix}consult/bad_rate_page`, { params })

// 获取好评页数据
export const consultGoodRatePage = params =>
  axios.get(`${prefix}consult/good_rate_page`, { params })

// 预取订单价格
export const preOrderInfo = data =>
  axios.post(`${prefix}consult_order/pre_create_order_info`, data)

// 是否在预沟通/首单白名单
export const isInWhiteListApi = user_id =>
  axios.get(`${prefix}consult/feedback_report/teacher_white`, {
    params: { user_id }
  })

// 提供服务（咨询独有）
export const getConsultService = params =>
  axios.get(`${prefix}user_home/consult_service`, { params })

// 咨询用户信息
export const getConsultUserInfo = params =>
  axios.get(`${prefix}consult/consult_user`, {
    params
  })

// 提供服务（全局）
export const getServiceInfo = params =>
  axios.get(`${prefix}user_home/services`, { params })

export const fetchZXRecord = params =>
  axios.get(`${prefix}layered/zixun_record`, { params })

// 体检报告往期
export const fetchCPReport = params =>
  axios.get(`${prefixMse}user/api/app/consult/anxietyEvaluationReport`, {
    params
  })

// 获取老师助理id
export const getAssistantId = params =>
  axios.get(`${prefix}consult/offline_teacher/info`, { params })

// 领取激励奖励
export const receiveIncentives = data =>
  axios.post(`${prefix}consult/room/receive_incentives`, data)

// 2024女神节活动信息
export const getGoddessActivityInfo = () =>
  axios.get(`${prefix}consult_activity/2024/iwd/activity_info`)

// 咨询邀请有礼推荐老师列表
export const getInviteteacherList = () =>
  axios.get(`${prefix}consult_activity/2022/invite/recommend_teacher`)

// 是否打了低价标签的用户
export const getLowerPriceUser = params =>
  axios.get(`${prefixMse}user/api/userInfo/consult/price/lower`, {
    params
  })

// 激励奖励通知阶梯点击激励
export const rewardNoticeStepApi = data =>
  axios.post(`${prefix}consult/reward_notice_step`, data)
